import { Checkbox, Input, DatePicker } from "antd";
import dayjs from "dayjs";
import useAdBlockStore from "store/AdBlockStore";

const { RangePicker } = DatePicker;

const metadataOptions = [
  { key: 'brand_equity_f', label: 'Brand Equity' },
  { key: 'newitem_f', label: 'New Item' },
  { key: 'select_varieties_f', label: 'Select Varieties' },
  // { key: 'bulkqty_f', label: 'Bulk Quantity' },
  { key: 'anomaly_f', label: 'Anomaly' },
  { key: 'split', label: 'Split' },
  { key: 'sponsored_f', label: 'Sponsored' },
  { key: 'qr_code_f', label: 'QR Code' },
  { key: 'coupon_f', label: 'Coupon' },
  { key: 'rebate_f', label: 'Rebate' },
  { key: 'limitedtime_f', label: 'Limited Time' },
  { key: 'show_math_f', label: 'Show Math' },
  { key: 'loyalty_f', label: 'Loyalty' },
  { key: 'meal_deal_f', label: 'Meal Deal' },
  { key: 'online_only_f', label: 'Online Only' },
  { key: 'sugar_tax_f', label: 'Sugar Tax' },
  // { key: 'inc_discount_f', label: 'Inc Discount' },
  { key: 'sold_out_f', label: 'Sold Out' }
];

const MetaDataSelector = () => {
  const store = useAdBlockStore();

  const hasAdultBeverage = store.products?.some(product => product.is_adult_bev === true || product.sub_cat_i === null) || false;

  const isCheckboxDisabled = key => {

    if (key === 'brand_equity_f') {
      const offers = store.offers;
      const incentive = store.incentive;
      // disableApprove = isBrandEquitySelected ? (offerData.length || incentiveData.length && incentiveData.some(i => i.incentive_attach_to === 'Adblock')) : !offerData.length && !incentiveData.length;
      if (offers?.length || (incentive?.length && incentive?.some(i => i.incentive_attach_to === 'Adblock'))) {
        if (store.brand_equity_f) {
          useAdBlockStore.setState({ brand_equity_f: false });
        }
        return true;
      }
    }

    // Coupon box is disabled unless a coupon signal is present (PEP-6516).
    // couponDisabled is kept in sync by syncCouponFlags.
    if (key === 'coupon_f') {
      return !!store.couponDisabled || (!!store.rebate_f && !store.coupon_f);
    }

    // AD-4468: Coupon and Rebate are mutually exclusive. Only the unchecked box
    // is locked, so a block that already carries both can still be fixed.
    if (key === 'rebate_f') {
      return !!store.coupon_f && !store.rebate_f;
    }

    return false;
  };

  return (
    <div className="flex flex-col gap-2">
      {metadataOptions.map(({ key, label }) => (
        <div key={key} className="flex flex-col gap-1">
          <Checkbox
            style={{ padding: '2px 0', userSelect: 'none' }}
            checked={store[key]}
            disabled={isCheckboxDisabled(key)}
            onChange={(e) => {
              useAdBlockStore.setState({ [key]: e.target.checked })
              if (key === 'coupon_f' && !e.target.checked)
                useAdBlockStore.setState({ coupon_amnt: 0 })
            }}
          >
            {label}
          </Checkbox>
          {key === 'coupon_f' && store.coupon_f && (
            <Input
              id="coupon_ammt"
              value={store.coupon_amnt}
              onChange={(e) => useAdBlockStore.setState({ coupon_amnt: e.target.value })}
              placeholder="Coupon Value"
              className="mt-1"
              autoComplete="on"
            />
          )}
          {key === 'rebate_f' && store.rebate_f && (
            <Input
              value={store.rebate_amnt}
              onChange={(e) => useAdBlockStore.setState({ rebate_amnt: e.target.value })}
              placeholder="Rebate Value"
              className="mt-1"
            />
          )}
          {key === 'limitedtime_f' && store.limitedtime_f && (
            <RangePicker
              value={[
                store.lt_start_dt ? dayjs(store.lt_start_dt) : null,
                store.lt_end_dt ? dayjs(store.lt_end_dt) : null
              ]}
              onChange={(dates, dateStrings) => useAdBlockStore.setState({ 
                lt_start_dt: dateStrings[0],
                lt_end_dt: dateStrings[1]
              })}
              className="mt-1"
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default MetaDataSelector;


